/**
 * 股吧 web 相关功能模块
 */

import {getH} from "./h";
import md5 from "./guba_md5";
import user from "../user";



export default {
  /**
   * 加关注-人
   */
  async addFollowPerson(uid:string){
    let thisuser = user.get()
    if(thisuser == null){
      return {
        re: false,
        message: '未登录'
      }
    }
    return $.ajax({
      url: '//gbapi.eastmoney.com/followopt/api/Follow/FollowUser4Jsonp?callback=?',
      type: 'GET',
      dataType: 'jsonp',
      data: {
        followuid: uid,
        h:getH(),
        version:"100",
        product:"EastMoney",
        plat:"Web",
        deviceid: md5.hex_md5(thisuser.id)
      }
    }).then(function(result){
      if(result.rc == 1){
        return {
          re: true
        }
      }
      else{
        return {
          re: false,
          message: result.me
        }
      }
    })
  },
  /**
   * 获取热门股吧-美股
   */
  async getHotUSGubaList(){
    return $.ajax({
      url: '/newapi/gethotgubalist_us',
      type: 'GET',
      dataType: 'json'
    })
  },
  /**
   * 获取热门股吧-港股
   */
  async getHotHKGubaList(){
    return $.ajax({
      url: '/newapi/gethotgubalist_hk',
      type: 'GET',
      dataType: 'json'
    })
  }
  
}